import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, ChevronDown, ChevronUp, BellOff, Flame } from "lucide-react";
import api from "@/lib/api";

export function RefOverdueTile() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/admin/ref-overdue").then(r => setData(r.data)).catch(() => setData({ total: 0, escalated: 0, teams: [] })); }, []);
  if (!data) return null;
  const none = data.total === 0;
  return (
    <div className={`card-tactical rounded-md border mb-10 ${none ? "border-[#83B68B]/40" : "border-amber-400/50 bg-amber-500/[0.04]"}`} data-testid="admin-ref-overdue-tile">
      <button type="button" onClick={() => !none && setOpen(o => !o)} className="w-full text-left p-5 flex items-center justify-between gap-4 flex-wrap" data-testid="admin-ref-overdue-toggle">
        <div className="flex items-center gap-4">
          <div className={`w-12 h-12 rounded border flex items-center justify-center flex-shrink-0 ${none ? "bg-[#83B68B]/15 border-[#83B68B]/40" : "bg-amber-500/15 border-amber-400/40"}`}>
            <ClipboardList className={`w-6 h-6 ${none ? "text-[#83B68B]" : "text-amber-300"}`} />
          </div>
          <div>
            <div className="flex items-baseline gap-3 flex-wrap">
              <span className={`font-display font-black text-3xl ${none ? "text-[#83B68B]" : "text-amber-300"}`} data-testid="admin-ref-overdue-count">{data.total}</span>
              <span className="font-display tracking-tight text-xl">played game{data.total === 1 ? "" : "s"} missing referee or expense</span>
              {data.escalated > 0 && <span className="text-[9px] tracking-widest uppercase px-1.5 py-0.5 rounded border border-red-400/50 text-red-300 bg-red-500/10 inline-flex items-center gap-1" data-testid="admin-ref-overdue-escalated"><Flame className="w-3 h-3" /> {data.escalated} over 7 days</span>}
            </div>
            <p className="text-xs opacity-80 mt-1">{none ? "All post-match referee admin is complete." : `${data.teams.length} team${data.teams.length === 1 ? "" : "s"} · head coaches are reminded daily; 7+ days escalates to the referee coordinator & treasurer.`}</p>
          </div>
        </div>
        {!none && (open ? <ChevronUp className="w-5 h-5 opacity-60" /> : <ChevronDown className="w-5 h-5 opacity-60" />)}
      </button>
      {open && (
        <div className="border-t border-border divide-y divide-border" data-testid="admin-ref-overdue-list">
          {data.teams.map(t => (
            <div key={t.team_id || "none"} className="p-4" data-testid={`admin-ref-overdue-team-${t.team_id || "none"}`}>
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="font-display font-bold">{t.team_name}</div>
                <span className={`text-[10px] tracking-widest uppercase px-2 py-0.5 rounded border ${t.max_days >= 7 ? "border-red-400/50 text-red-300" : "border-amber-400/40 text-amber-300"}`}>{t.max_days} day{t.max_days === 1 ? "" : "s"} overdue</span>
              </div>
              <ul className="mt-2 space-y-1 text-xs">
                {t.games.map(g => (
                  <li key={g.booking_id} className="flex items-center justify-between gap-3 flex-wrap">
                    <Link to={`/app/bookings?booking_id=${g.booking_id}`} className="hover:text-[#83B68B] underline-offset-2 hover:underline" data-testid={`admin-ref-overdue-game-${g.booking_id}`}>{g.label}</Link>
                    <span className="opacity-70">{g.missing.join(" · ")} · {g.days_overdue}d{g.muted ? <span className="ml-2 inline-flex items-center gap-1 opacity-60"><BellOff className="w-3 h-3" /> muted</span> : g.nudge_to?.length ? ` · nudging ${g.nudge_to.join(", ")}` : ""}{g.escalated_at ? " · escalated" : ""}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
